<template>
    <modal :name="modalName"
        :adaptive="true"
        :width="500"
        height="auto"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
        @before-close="handleBeforeClose"
    >
        <div class="rounded-lg bg-white p-8"
            @click.stop
        >
            <div class="flex flex-col mb-6">
                <div class="flex-shrink-0 leading-snug text-gray-600 text-lg">
                    Are you sure you want to delete this envelope?
                </div>

                <div class="text-gray-600 leading-tight mt-4 mb-0 outline-none" tabindex="0">
                    This cannot be undone.
                </div>
            </div>

            <div class="flex items-center justify-between pt-4">
                <button-gray-outline @click="close">
                    Cancel
                </button-gray-outline>

                <button-red @click="deleteEnvelope">
                    Delete
                </button-red>
            </div>
        </div>
    </modal>
</template>

<script>
import ButtonRed from '../../../components/button-red.vue';
import ButtonGrayOutline from '../../../components/button-gray-outline.vue';

export default {
    components: {
        ButtonRed,
        ButtonGrayOutline,
    },

    props: {
        show: {},
        modal_name: { default: 'envelope-delete-modal' },
    },

    computed: {
        modalName() {
            return this.modal_name;
        },
    },

    methods: {
        close(event) {
            this.$modal.hide(this.modalName);
            this.$nextTick(() => {
                this.$emit('closed');
            });
        },
        handleBeforeClose(event) {
            // Only emit closed if the close wasn't triggered by our buttons
            if (! event.stop) {
                this.$emit('closed');
            }
        },
        deleteEnvelope() {
            this.$emit('deleteEnvelope');
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.$modal.show(this.modalName);
            } else {
                this.$modal.hide(this.modalName);
            }
        },
    },
}
</script>

<style scoped>
.vm--overlay {
    background: #000000;
    opacity: 0.7;
}

.overlay-enter,
.overlay-leave-to {
    opacity: 0;
}

.overlay-enter-active,
.overlay-leave-active {
    transition: all .3s;
}
</style>
